import React from 'react';
import { useNavigate } from 'react-router-dom';

const materias = [
  'Meteorologia',
  'Conhecimentos Técnicos',
  'Teoria de Voo',
  'Regulamentos',
  'Navegação',
];

export default function MateriaSelect({ onSelect }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'url(/cockpit.jpg) center/cover no-repeat',
      position: 'relative',
    }}>
      {/* Botão de Logout */}
      <button
        onClick={handleLogout}
        style={{
          position: 'absolute',
          top: 20,
          right: 20,
          padding: '12px 24px',
          fontSize: 16,
          borderRadius: 8,
          border: 'none',
          background: '#f44336',
          color: '#fff',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          fontWeight: 600,
          transition: 'background 0.2s',
        }}
        onMouseOver={e => e.currentTarget.style.background = '#d32f2f'}
        onMouseOut={e => e.currentTarget.style.background = '#f44336'}
      >
        Sair
      </button>

      <h2 style={{ color: '#fff', marginBottom: 32, fontWeight: 700, fontSize: '2em', textShadow: '2px 2px 8px #0008' }}>
        Selecione a matéria do simulado
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 32,
        width: '100%',
        maxWidth: 700,
        margin: '0 auto',
        padding: '24px',
        background: 'rgba(255,255,255,0.7)',
        borderRadius: 24,
        boxShadow: '0 4px 24px #0003',
      }}>
        {materias.map(materia => (
          <button
            key={materia}
            onClick={() => onSelect(materia)}
            style={{
              padding: '32px 0',
              fontSize: 22,
              borderRadius: 16,
              border: 'none',
              background: '#1976d2',
              color: '#fff',
              cursor: 'pointer',
              boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
              fontWeight: 600,
              letterSpacing: 1,
              transition: 'transform 0.1s',
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            {materia}
          </button>
        ))}
      </div>
    </div>
  );
}
